import { lazy } from 'react';

const PaymentFailedComponent = lazy(() =>
    import('../../../shared/ui/PaymentHandling/PaymentFailedComponent')
);
const PaymentPendingComponent = lazy(() =>
    import('../../../shared/ui/PaymentHandling/PaymentPendingComponent')
);
const PaymentSuccessComponent = lazy(() =>
    import('../../../features/payment/presentation/payment-status')
);
const PaymentLinkComponent = lazy(() =>
    import('../../../shared/ui/PaymentHandling/PaymentLinkComponent')
);
const DetailPembayaran = lazy(() =>
    import('../../../features/payment/presentation/payment-detail')
);
const MetodePembayaranComponent = lazy(() =>
    import('../../../features/payment/presentation/payment-method')
);

const PaymentRoutes = [
    {
        key: "key.detailpembayaran",
        path: '/detailpembayaran',
        component: DetailPembayaran,
        name: 'Detail Pembayaran'
    },
    {
        key: "key.metodepembayaran",
        path: '/metodepembayaran',
        component: MetodePembayaranComponent,
        name: 'Metode Pembayaran'
    },
    {
        key: "key.paymentsuccess",
        path: '/paymentsuccess',
        component: PaymentSuccessComponent,
        name: 'Payment Success'
    },
    {
        key: "key.paymentfailed",
        path: '/paymentfailed',
        component: PaymentFailedComponent,
        name: 'Payment Failed'
    },
    {
        key: "key.paymentpending",
        path: '/paymentpending',
        component: PaymentPendingComponent,
        name: 'Payment Pending'
    },
    {
        key: "key.paymentlink",
        path: '/paymentlink',
        component: PaymentLinkComponent,
        name: 'Payment Link'
    },
]

export default PaymentRoutes;